export default __webpack_public_path__ + "static/7-1262c3375c881c2ba0f227f3ccbb33a5.jpg";